<template>
<ProfileCard title="Счетчики">
  <div class="counters-table">
    <div class="counters-table-header counters-table-row">
      <div class="counters-table-col0">Тесты</div>
      <div class="counters-table-col1">За месяц</div>
      <div class="counters-table-col1">За все время</div>
    </div>
    <v-expansion-panels
      v-model="panel"
      multiple
    >
      <v-expansion-panel
        class="accordion"
        v-model="panel"
        :active-class="'active-expansion'"
        v-for="(counter,idx) of statisticsCounter"
        :key="idx"

      >
        <v-expansion-panel-header class="pa-0 mt-2">
          <div class="counters-table-col0 header">
            {{counter.name}}
            <v-btn fab class="mb-2" small text _outlined @click="$emit('add',counter)" v-if="checkOpenExpansion(idx) && enableAdd">
              <v-icon >mdi-pencil-outline</v-icon>
            </v-btn>
          </div>

        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0 ps-2">
          <div class="counters-table-row">
            <div class="counters-table-col0">Отправлено тестов</div>
            <div class="counters-table-col1">{{counter.data.licenses_spent_last_month || 0}}</div>
            <div class="counters-table-col2">{{counter.data.licenses_spent || 0}}</div>
          </div>
          <div class="counters-table-row">
            <div class="counters-table-col0">Получено тестов</div>
            <div class="counters-table-col1">{{counter.data.licenses_received_last_month || 0}}</div>
            <div class="counters-table-col2">{{counter.data.licenses_received || 0}}</div>
          </div>
          <div class="counters-table-row">
            <div class="counters-table-col0">Осталось</div>
            <div class="counters-table-col1"></div>
            <div class="counters-table-col2">{{counter.data.amount || 0}}</div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </div>
</ProfileCard>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ProfileCardExpansionCounter',
  components: {},
  data: () => ({
      panel: false,
    }),
  props: {
    enableAdd: Boolean,
    user: { type: [Object, null], },
    userType: {
      type: String,
    }
  },
  computed: {
    ...mapGetters({
      licenseReceived: 'auth/licenseReceived',
      userCounters: 'auth/getUserCounters',
      getCurrentCountersDetail: 'users/counters/getCurrentCountersDetail'
    }),
    statisticsCounter() {
      if (this.user) {
        const hasBalanceData = this.getCurrentCountersDetail?.balance_detailed !== undefined;

        if (!hasBalanceData) {
          return [];
        }

        // if (!this.getCurrentCountersDetail?.stock_balance) return [];

        const balanceDetailed = this.getCurrentCountersDetail?.balance_detailed;
        if (!balanceDetailed.length) return [];

        const licenseReceived = this.user.licences_received_spent || {};
        const licenseKeys = Object.keys(licenseReceived);

        if (licenseKeys.length === 0) return [];

        const licenseMap = new Map(
          Object.entries(licenseReceived).filter(([, value]) => value != null)
        );

        return balanceDetailed
          .filter(item => licenseMap.has(item.code))
          .map(item => ({
            name: item.name,
            data: {
              ...licenseMap.get(item.code),
              ...item
            },
            active: false,
          }));
      }
        const hasBalanceData = this.userCounters?.balance_detailed !== undefined;

        if (!hasBalanceData) {
          return [];
        }

        if (!this.userCounters?.stock_balance) return [];

        const balanceDetailed = this.userCounters?.balance_detailed;
        if (!balanceDetailed.length) return [];

        const licenseReceived = this.licenseReceived || {};
        const licenseKeys = Object.keys(licenseReceived);

        if (licenseKeys.length === 0) return [];

        const licenseMap = new Map(
          Object.entries(licenseReceived).filter(([, value]) => value != null)
        );

        return balanceDetailed
          .filter(item => licenseMap.has(item.code))
          .map(item => ({
            name: item.name,
            data: {
              ...licenseMap.get(item.code),
              ...item
            },
            active: false,
          }));
    },

  },
  emits: ['add'],
  methods: {
    ...mapActions({
      getStockBalances: 'users/counters/getStockBalance',
    }),
    ...mapMutations({
      setUserCounters: 'users/counters/setUserCounters',
    }),
    checkOpenExpansion(idx) {
      if (this.panel && idx !== undefined && this.panel.length && this.panel.includes(idx)) {
        return true;
      }
      return false;
    },
    async getStockBalance() {
      if (this.user.id && this.userType) {
        const response = await this.getStockBalances({ toType: this.userType, toId: this.user?.id });
        this.setUserCounters(response);
        return response;
      }
    }
  },
  watch: {
   async user(current) {
      if (current) {
        await this.getStockBalance();
      }
    }
  },
};
</script>

<style scoped lang="scss">
.counters-table {
  width: 100%;
  // max-width: 700px;
  // font-size: 13px;
  margin: 0 10px 0 0;

  .counters-table-header {
    font-weight: 600;
    padding: 10px 0 !important;
    & .counters-table-col0{
      color: var(--color-blue-500);
    }
  }
  .counters-table-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding: 8px 0;
    border-bottom: 1px solid #ccc;
    &:last-child {
      border-bottom: none;
    }
  }

  .counters-table-col0 {
    width: 40%;
    font-size: 16px;
    &.header{
      font-weight: 500;
      color: var(--color-blue-500);
    }
  }

  .counters-table-col1, .counters-table-col2 {
    width: 30%;
    text-align: right;
  }

}

</style>
